import {MAP_LAYERS, openstreetmap} from '../constants/layers'

export const getMapLayersProps = (key: string) => {
    if(!(key in MAP_LAYERS)){
        return  {
            url:openstreetmap.url
        }
    }
    return MAP_LAYERS[key]
}